import * as React from 'react';
import styled from "styled-components";
import themes from "@/styles/themes";
import Icon from '@mdi/react';
import { mdiAlertOutline, mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js';
import { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SET_LEAD_CELULAR,
  SET_LEAD_DOCUMENTO,
  SET_LEAD_EMAIL
} from "@/store/slices/leadSlice";
import { GET_ALL_STATE } from "@/store/slices/appSlice";
import Lead from "@/utils/Lead";
import Input from '../Input'
import Nullable from '@/types/utils/Nullable';

const LabelStyle = styled.label`
  pointer-events: none;
  color: ${themes.estadao};
  font-size: 16px;
  position: absolute;
  top: 15px;
  left: 15px;
  transition: all .3s ease-out;
  -webkit-transition: all .3s ease-out;
  -moz-transition: all .3s ease-out;

  &.cvv {
    font-size: 14px;
    top: 16px;
    left: 11px;
  }
`

const ButtonHiddenPassword = styled.button`
  position: absolute;
  top: 13px;
  display: flex;
  right: 10px;
  background: #ffffff00;
  border: none;
  cursor: pointer;

  svg {
    color: ${themes.estadao};
  }
`
const LabelAlert = styled.label`
  z-index: 9999;
  pointer-events: none;
  color: ${themes.red};
  font-size: 16px;
  position: absolute;
  top: 15px;
  right: 15px;
  transition: all .3s ease-out;
  -webkit-transition: all .3s ease-out;
  -moz-transition: all .3s ease-out;
  display: none;
`

const FormGroup = styled.div`
  position: relative;
  margin: 8px 0 0 0;

  &.group-invalid {
    input.input {
      border: 1px solid ${themes.red} !important;
      display: block;

      
    }

    ${ButtonHiddenPassword} {
      svg {
        color: ${themes.red};
      }
    }

    span.error {
      color: ${themes.redDark};
      font-size: 12px;
      margin: 0;
      padding: 0;
    }


    ${LabelStyle} {
      color: ${themes.red} !important;
    }

    ${LabelAlert} {
      display: block;
    }
  }

  &.group-valid {
    input.input {
      border: 1px solid ${themes.green};
      box-shadow: 0 0 5px ${themes.green};
      display: block;
    }

    span.error {
      display: none;
    }


    ${LabelStyle} {
      color: ${themes.green} !important;
    }

    ${ButtonHiddenPassword} {
      svg {
        color: ${themes.green};
      }
    }
  }

  input.input {
    border: 1px solid ${themes.estadao};
    border-radius: 5px;
    outline: none;
    width: 100%;
    font-size: 16px;
    transition: all .3s ease-out;
    -webkit-transition: all .3s ease-out;
    -moz-transition: all .3s ease-out;
    -webkit-appearance: none;
    height:50px;
    padding-left: 14px;
    padding-top: 14px;
    &:focus {
      box-shadow: 0 0 0 2px rgba(37, 117, 232, .3);
    }

    &::placeholder {
      color: transparent;
      margin-top:20px;
    }

    &:required:invalid + ${LabelStyle} {
      color: ${themes.red};
    }

    &:focus:required:invalid {
      border-bottom: 2px solid ${themes.red};
    }

    &:required:invalid + ${LabelStyle}:before {
      content: '*';
    }

    &:focus + ${LabelStyle},
    &:not(:placeholder-shown) + ${LabelStyle} {
      font-size: 12px;
      margin-top: -10px;
      margin-left: 0;

      color: ${themes.estadao};
    }
  }
`


export default function InputWithValidation(props: {
  name: string,
  type: string,
  placeholder: string,
  value?: string,
  id: string,
  disabled?: boolean,
  OnClick?: Function,
  onChange: (value: any) => void,
  onFocus?: (event: any) => void,
  onBlur?: (event: any) => void,
  errorMessage: Nullable<string>
  maxLenght?: number,
  minLenght?: number
  readOnly?: boolean
}) {
  const { name } = props
  const dispatch = useDispatch()
  const [typeRender, setType] = useState(props.type)
  const second = useMemo((): string => {
    if (props.errorMessage === null) {
      return ''
    }

    if (props.errorMessage === '') {
      return 'group-valid'
    }

    return 'group-invalid'
  }, [props])

  const states = useSelector(GET_ALL_STATE)
  const all_states = useMemo(() => states, [states])

  const masks = useMemo((): string[] | undefined => {
    switch (name.toString().toLowerCase()) {

      case 'documento':
        return [
          '000.000.000-00',
          '00.000.000/0000-00',
          '**.***.***/****-00'
        ]
      case 'telefone':
      case 'celular':
        return [
          '(00) 0000-0000',
          '(00) 0 0000-0000'
        ]
      case 'dt_nascimento':
        return [
          '00/00/0000'
        ]
      case 'validade':
        return ['00/00']
      case 'cvv':
        return ['000', '0000']
      case 'numero':
        return [
          '0000 0000 0000 0000',
          '0000 000000 00000',
          '0000 000000 0000'
        ]
      case 'cep':
        return ['00000-000']
      case 'agencia':
        return ['0000']
      case 'agencia_digito':
        return ['0-9']
      case 'conta':
        return ['0000000']
      case 'digito':
        return ['0-9']
    }

    return undefined
  }, [name])

  function switchType() {
    if (typeRender === 'text') {
      setType(props.type)
    } else {
      setType('text')
    }
  }

  function submitLead() {
    Lead.save(all_states.lead.value, dispatch)
  }

  function leadFunction(event: any) {
    switch (name.toString().toLowerCase()) {
      case 'documento':
        dispatch(SET_LEAD_DOCUMENTO(event.target.value))
        submitLead()
        break;
      case 'email':
        dispatch(SET_LEAD_EMAIL(event.target.value))
        submitLead()
        break;
      case 'celular':
      case 'telefone':
        dispatch(SET_LEAD_CELULAR(event.target.value))
        submitLead()
        break;
    }
  }

  const sendLeadAndEvent = (e: any) => {
    leadFunction(e);
    if (props.OnClick) {
      props.OnClick();
    }
  }

  const validationPassword = () => {
    if (second === 'group-invalid') return false
    else if (props.type === 'password') return true
  }

  return (
    <FormGroup className={second}>
      <Input
        onChange={props.onChange}
        onClick={(e: any) => sendLeadAndEvent(e)}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        className={`input ${name}`}
        name={name}
        value={props.value}
        placeholder={props.placeholder}
        type={typeRender}
        masks={masks}
        disabled={props.disabled}
        minLenght={props.minLenght}
        maxLenght={props.maxLenght}
        readOnly={props.readOnly}
      />
      <LabelStyle htmlFor={name} className={`label ${name}`}>{props.placeholder}</LabelStyle>
      <LabelAlert>
        <Icon path={mdiAlertOutline} size={1} />
      </LabelAlert>
      {validationPassword() && <ButtonHiddenPassword onClick={switchType} type={'button'}>
        <Icon path={typeRender === 'text' ? mdiEyeOffOutline : mdiEyeOutline} size={1}></Icon>
      </ButtonHiddenPassword>}
      {props.errorMessage &&
        <span className={'error'}>{props.errorMessage.replace(new RegExp(name, 'g'), props.placeholder)}</span>}
    </FormGroup>
  )
}